export default __webpack_public_path__ + "static/media/carousel2.5031be75.png";